import React from 'react';

import { ApiRequest, PagedList, PagedListPayload } from 'framework/api';
import { Asset } from 'framework/entities/asset';
import { AssetGroup } from 'framework/entities/assetGroup';
import { UrlBuilder } from 'tools/urlBuilder';
import { getAssetGroupAssets } from 'areas/assets/api';
import { useDataHolder } from 'framework/data-loading/dataHolder';

interface GetAssetGroupAssetsArgs {
	assetGroupId: string;
	accountId?: string;
	payload: PagedListPayload;
}

export function getAssetGroupAssetsPaged(args: GetAssetGroupAssetsArgs) {
	const url = new UrlBuilder('/health/assetGroups/' + args.assetGroupId + '/assets').build();
	return new ApiRequest<PagedList<Asset>>({
		url,
		accountId: args.accountId,
		accountBased: true,
		method: 'POST',
		payload: args.payload,
	});
}

export function getAssetGroup(id: string, update = false) {
	const url = new UrlBuilder('/assetGroups/' + id).add('update', 'true', update).build();

	return new ApiRequest<AssetGroup>({
		url: url,
		accountBased: true,
	});
}

type UseAssetGroupAssetsArgs = {
	accountId?: string;
	assetGroupId?: string;
	agentsOnly?: boolean;
	systemType?: string;
};

export function useAssetGroupAssets(args: UseAssetGroupAssetsArgs) {
	const request = React.useMemo(
		() =>
			args.assetGroupId && args.accountId
				? getAssetGroupAssets({
						accountId: args.accountId,
						assetGroupId: args.assetGroupId,
						agentsOnly: args.agentsOnly,
						systemType: args.systemType,
					})
				: null,
		[args.accountId, args.assetGroupId, args.agentsOnly, args.systemType],
	);

	const defaultValue = React.useMemo(() => [] as Asset[], []);

	return useDataHolder({
		request: request,
		defaultValue: defaultValue,
	});
}
